export default __webpack_public_path__ + "media/images/cafe-5fb33c72f745ea199c4b80b283f9149b.jpg";